import { Configuration } from '@azure/msal-browser';

const clientId = import.meta.env.VITE_CLIENT_ID as string | undefined;
const tenantId = import.meta.env.VITE_TENANT_ID as string | undefined;
const apiClientId = (import.meta.env.VITE_API_CLIENT_ID || import.meta.env.VITE_CLIENT_ID) as string | undefined;

export const msalConfig: Configuration = {
  auth: {
    clientId: clientId || '',
    authority: `https://login.microsoftonline.com/${tenantId || ''}`,
    redirectUri: window.location.origin,
  },
  cache: { cacheLocation: 'sessionStorage' },
};

export const apiScopes: string[] = apiClientId ? [`api://${apiClientId}/access_as_user`] : [];

export const msalConfigErrors: string[] = [
  ...(!clientId ? ['VITE_CLIENT_ID is missing.'] : []),
  ...(!tenantId ? ['VITE_TENANT_ID is missing.'] : []),
  ...(!apiClientId ? ['VITE_API_CLIENT_ID (or VITE_CLIENT_ID fallback) is missing.'] : []),
];
